export default "__VITE_ASSET__b82edc4d__"